import {checkAUSite, checkCASite, checkNZSite} from '../modules/sms-validation'
import {getApplicationFormSelectors, getSummaryPageSelectors,} from '../util/applicationFormSummarySelectors'

const isAUSite = checkAUSite()
const isCASite = checkCASite()
const isNZSite = checkNZSite()

export default function RenderSummaryPageData(elements, country) {
    const {form, stepProgress, submitApplicationButton} = elements

    /** Modify Classnames for certain elements */
    stepProgress.classList.add(`hide`)
    form.classList.add(`last-step`)

    /**
     * Get the Summary Page Output Selectors
     * Output selectors are used to display the final formatted values on the Summary page
     * It takes the input values and passes the values to the formatted output selector
     */
    const summarySelectors = getSummaryPageSelectors()
    const inputSelectors = getApplicationFormSelectors()

    /**
     * Summary : Step 5 Labels
     */
    let driversLicenseLabel = `Drivers licence`
    let driversLicenseCardLabel = `Card number`
    let driversLicenseStateOfIssue = `State of issue`
    if (country === `CA`) {
        driversLicenseStateOfIssue = `Province of issue`
        driversLicenseLabel = `Drivers licence`
    }
    if (country === `NZ`) {
        driversLicenseLabel = `Licence number`
    }

    /**
     * Summary : Step 6 Label
     */
    const appBusinessNumberLabel = isNZSite
        ? `New Zealand business number (NZBN)`
        : `Australian business number (ABN)`

    /**
     * Reset the summary page output selector values
     * When a user clicks 'edit' or 'back' the summary output
     * selectors retain the original values
     */
    resetSummaryPageOutputValues(summarySelectors)

    /**
     * Summary : Step 2 & 3 Output Values (Personal & Contact Details)
     */
    if (
        summarySelectors.appValueName &&
        inputSelectors.applicationFirstName &&
        inputSelectors.applicationFirstName.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueName,
            `Name`,
            `${inputSelectors.applicationFirstName.value} ${inputSelectors.applicationMiddleName.value} ${inputSelectors.applicationLastName.value}`,
            false
        )
    }
    if (
        summarySelectors.appValuePhone &&
        inputSelectors.applicationPhone &&
        inputSelectors.applicationPhone.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValuePhone,
            `Mobile number`,
            inputSelectors.applicationPhone.value,
            false
        )
    }
    if (
        summarySelectors.appValueEmail &&
        inputSelectors.applicationEmail &&
        inputSelectors.applicationEmail.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueEmail,
            `Email`,
            inputSelectors.applicationEmail.value,
            false
        )
    }
    if (
        summarySelectors.appValueAddress &&
        inputSelectors.applicationAddress &&
        inputSelectors.applicationAddress.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueAddress,
            `Home address`,
            `<span>${inputSelectors.applicationAddressLine2.value ? `${inputSelectors.applicationAddressLine2.value}/` : ``}${inputSelectors.applicationAddress.value}</span>, <span>${inputSelectors.applicationAddressCity.value}</span>, <span>${inputSelectors.applicationAddressZip.value}</span>, <span>${inputSelectors.applicationAddressState.value}</span>`,
            false
        )
    }

    if (
        summarySelectors.appValueBirthday &&
        inputSelectors.applicationFormattedBirthday &&
        inputSelectors.applicationFormattedBirthday.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueBirthday,
            `Date of birth`,
            inputSelectors.applicationFormattedBirthday.value,
            false
        )
    }

    if (
        summarySelectors.appValueCustomerGender &&
        inputSelectors.applicationCustomerGender &&
        inputSelectors.applicationCustomerGender.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueCustomerGender,
            `Gender`,
            inputSelectors.applicationCustomerGender.value
        )
    }

    if (
        summarySelectors.appValueBusinessAddress &&
        inputSelectors.applicationBusinessAddress &&
        inputSelectors.applicationBusinessAddress.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueBusinessAddress,
            `Business address`,
            `<span>${inputSelectors.applicationBusinessAddressLine2.value ? `${inputSelectors.applicationBusinessAddressLine2.value}/` : ``}${inputSelectors.applicationBusinessAddress.value}</span>, <span>${inputSelectors.applicationBusinessCity.value}</span>, <span>${inputSelectors.applicationBusinessPostcode.value}</span>, <span>${inputSelectors.applicationBusinessState.value}</span>`,
            false
        )
    }

    /**
     * Summary (checked): Step 5 Output Values (Verify Details)
     */
    if (
        summarySelectors.appValueMedicareNameOnCard &&
        inputSelectors.applicationMedicareNameOnCard &&
        inputSelectors.applicationMedicareNameOnCard.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueMedicareNameOnCard,
            `Name on card`,
            inputSelectors.applicationMedicareNameOnCard.value,
            false
        )
    }

    if (
        summarySelectors.appValueMedicareNumber &&
        inputSelectors.applicationMedicareNumber &&
        inputSelectors.applicationMedicareNumber.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueMedicareNumber,
            `Medicare number`,
            inputSelectors.applicationMedicareNumber.value,
            false
        )
    }

    if (
        summarySelectors.appValueMedicareColor &&
        inputSelectors.applicationMedicareColor &&
        inputSelectors.applicationMedicareColor.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueMedicareColor,
            `Colour`,
            inputSelectors.applicationMedicareColor.value
        )
        summarySelectors.appValueMedicareColor.classList.remove(`hide`)
    } else {
        summarySelectors.appValueMedicareColor.classList.add(`hide`)
    }

    if (
        summarySelectors.appValueMedicarePosition &&
        inputSelectors.applicationmedicarePosition &&
        inputSelectors.applicationmedicarePosition.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueMedicarePosition,
            `Card position`,
            inputSelectors.applicationmedicarePosition.value
        )
        summarySelectors.appValueMedicarePosition.classList.remove(`hide`)
    } else {
        summarySelectors.appValueMedicarePosition.classList.add(`hide`)
    }

    if (
        summarySelectors.appValueMedicareExpiry &&
        inputSelectors.applicationmedicareExpiryMonth &&
        inputSelectors.applicationmedicareExpiryMonth.value !== `` &&
        inputSelectors.applicationmedicareExpiryYear &&
        inputSelectors.applicationmedicareExpiryYear.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueMedicareExpiry,
            `Expiry`,
            `${inputSelectors.applicationmedicareExpiryMonth.value}/${inputSelectors.applicationmedicareExpiryYear.value}`
        )
        summarySelectors.appValueMedicareExpiry.classList.remove(`hide`)
    } else {
        summarySelectors.appValueMedicareExpiry.classList.add(`hide`)
    }

    if (
        summarySelectors.appValueDriversLicense &&
        inputSelectors.applicationDriversLicense &&
        inputSelectors.applicationDriversLicense.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueDriversLicense,
            driversLicenseLabel,
            inputSelectors.applicationDriversLicense.value,
            false
        )
        summarySelectors.appValueDriversLicense.classList.remove(`hide`)
    } else {
        summarySelectors.appValueDriversLicense.classList.add(`hide`)
    }

    if (
        summarySelectors.appValueDriversLicenseCardNumber &&
        inputSelectors.applicationDriversLicenseCardNumber &&
        inputSelectors.applicationDriversLicenseCardNumber.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueDriversLicenseCardNumber,
            driversLicenseCardLabel,
            inputSelectors.applicationDriversLicenseCardNumber.value,
            false
        )
        summarySelectors.appValueDriversLicenseCardNumber.classList.remove(`hide`)
    } else {
        summarySelectors.appValueDriversLicenseCardNumber.classList.add(`hide`)
    }

    if (
        summarySelectors.appValueDriversLicenseVersion &&
        inputSelectors.applicationDriversLicenseVersion &&
        inputSelectors.applicationDriversLicenseVersion.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueDriversLicenseVersion,
            `Drivers licence version`,
            inputSelectors.applicationDriversLicenseVersion.value,
            false
        )
        summarySelectors.appValueDriversLicenseVersion.classList.remove(`hide`)
    } else {
        summarySelectors.appValueDriversLicenseVersion.classList.add(`hide`)
    }

    if (
        summarySelectors.appValueStateIssue &&
        inputSelectors.applicationStateIssue &&
        inputSelectors.applicationStateIssue.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueStateIssue,
            driversLicenseStateOfIssue,
            inputSelectors.applicationStateIssue.value
        )
    }

    /**
     * Summary : Step 6 Output Values (ABN Look Up)
     */
    if (
        summarySelectors.appValueIncorporation &&
        inputSelectors.incorporationNumber &&
        inputSelectors.incorporationNumber.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueIncorporation,
            `Business number`,
            inputSelectors.incorporationNumber.value,
            false
        )
    }

    if (
        summarySelectors.appValueTradingName &&
        inputSelectors.applicationTradingName &&
        inputSelectors.applicationTradingName.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueTradingName,
            `Trading name`,
            inputSelectors.applicationTradingName.value,
            false
        )
    }
    if (
        country != `AU` &&
        summarySelectors.appValueLegalName &&
        inputSelectors.applicationLegalName &&
        inputSelectors.applicationLegalName.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValueLegalName,
            `Legal name`,
            inputSelectors.applicationLegalName.value,
            false
        )
    }
    /**
     * NZBN Private Legal Business Name (entity)
     */
    if (
        summarySelectors.appValuePrivateLegalName &&
        inputSelectors.applicationPrivateLegalName &&
        inputSelectors.applicationPrivateLegalName.value !== ``
    ) {
        renderFieldValue(
            summarySelectors.appValuePrivateLegalName,
            `Legal Name`,
            inputSelectors.applicationPrivateLegalName.value,
            false
        )
    }

    // Australian ABN Number & NZBN Number
    if (
        summarySelectors.appValueABNnumber &&
        inputSelectors.hiddenBusinessNumberInputField &&
        inputSelectors.hiddenBusinessNumberInputField.value !== ``
    ) {
        let businessNumberLabelValue = inputSelectors.hiddenBusinessNumberInputField.value
        if (country === `AU`) {
            businessNumberLabelValue += ` (${inputSelectors.applicationLegalName.value})`
        }
        renderFieldValue(
            summarySelectors.appValueABNnumber,
            appBusinessNumberLabel,
            businessNumberLabelValue
        )
    }

    const privacy = document.getElementById(`privacy_policy_accepted`)
    const terms_accepted = document.getElementById(`terms_accepted`)
    const commercial_purposes_accepted = document.getElementById(`commercial_purposes_accepted`)
    const checkboxes = [privacy, terms_accepted, commercial_purposes_accepted]

    // Loop over checkboxes
    checkboxes.forEach((checkbox) => {
        if (checkbox) {
            checkbox.addEventListener(`change`, (element) => {
                handleCheckboxChange(submitApplicationButton)
            })
        }
    })

    submitApplicationButton.addEventListener(`sms-validated`, () => {
        handleCheckboxChange(submitApplicationButton)
    })

    // Setup Mutation Observer
    // Source: https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
    // Options for the observer (which mutations to observe)
    const config = {attributes: true, childList: false, subtree: false}

    // Callback function to execute when mutations are observed
    const callback = function (mutationsList, observer) {
        for (let mutation of mutationsList) {
            // Check that the mutation happened on an attribute && the attribute name was the recaptcha
            if (
                mutation.type === `attributes` &&
                mutation.attributeName === `data-valid-recaptcha`
            ) {
                handleCheckboxChange(submitApplicationButton)
            }
        }
    }

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback)

    // Start observing the target node for configured mutations
    observer.observe(submitApplicationButton, config)

    pushGoogleAnalyticsEvent(inputSelectors)
}

// Handles change events of each checkbox & recaptcha
function handleCheckboxChange(submitApplicationButton) {
    const checkboxIds = [
        `privacy_policy_accepted`,
        `terms_accepted`,
        `commercial_purposes_accepted`,
    ]
    const checkboxes = checkboxIds
        .map(checkboxId => {
            const checkbox = document.getElementById(checkboxId)
            return checkbox !== null ? checkbox : false
        })
        .filter(element => !!element)

    // Convert Data Recaptcha into a Boolean
    let recaptchaValid = submitApplicationButton.getAttribute(`data-valid-recaptcha`)
    let mobileNumberValid = submitApplicationButton.getAttribute(`data-valid-sms`)

    // If the Submit attr data-valid-recaptcha is TRUE , proceed to check the state of the checkboxes
    if (recaptchaValid === `true` && mobileNumberValid === `true`) {
        // If the User has Checked all Checkboxes, enabled Submit Button
        if (checkboxes.every(checkbox => checkbox && checkbox.checked)) {
            submitApplicationButton.classList.remove(`disabled`)
        } else {
            submitApplicationButton.classList.add(`disabled`)
        }
    }
}

function renderFieldValue(
    singleSummaryFormField,
    fieldLabelDescription,
    formInputValue,
    translate = true
) {
    return (singleSummaryFormField.innerHTML = `<span class="summary-accordion__label">${fieldLabelDescription}:</span> <span class="summary-accordion__value${translate ? `` : ` transifex-ignore`}">${formInputValue}</span>`)
}

function pushGoogleAnalyticsEvent(inputSelectors) {
    document.querySelector(`[type="submit"]`).addEventListener(`click`, () => {
        window.dataLayer.push({
            event: `AppFormSubmission`,
            first_name: inputSelectors.applicationFirstName.value,
            middle_name: inputSelectors.applicationMiddleName.value,
            last_name: inputSelectors.applicationLastName.value,
            mobile_number: inputSelectors.applicationPhone.value,
            email_address: inputSelectors.applicationEmail.value,
            submission_id: document.querySelector(`#submission_id`).value,
            country: isAUSite ? `Australia` : isCASite ? `Canada` : `New Zealand`
        })
    })
}

function resetSummaryPageOutputValues(outputSelectors) {
    Object.values(outputSelectors).forEach(inputContainer => {
        if (inputContainer) {
            inputContainer.innerHTML = ``
        }
    })
}

export {handleCheckboxChange}
